export const CONNECTOR_CAPABILITIES = [
  {
    id: "login",
    title: "Log in with a scan, not a password",
    body: "Register your OAuth 2.0 client, drop the CorePass login page into your own application, and exchange the code you get back for a token that names the user. Signing up and signing in are the same action, so a first-time visitor becomes a known user in exactly the gesture a returning one uses to come back.",
    bullets: [
      "Identify returning users by a stable Core ID rather than an email address.",
      "Retire password resets, verification emails and the recovery tickets they generate.",
    ],
  },
  {
    id: "kyc",
    title: "Receive the data compliance asks for",
    body: "Ask the Connector which of the fields you need a person has already verified, show them a request listing exactly those fields and nothing else, and receive the values at your callback once they accept on their own phone. The exchange is settled peer to peer, the person is paid in Core Token for what they release, and the window to accept is a matter of minutes.",
    bullets: [
      "Ask for a passport number or a date of birth, never the whole document.",
      "Re-check later whether the data you already hold is still valid, field by field.",
    ],
  },
  {
    id: "kyb",
    title: "Verify a business, not only a person",
    body: "KYB answers for a company rather than an individual: its members vote, and the registry data they release reaches your webhook inside a signed attestation whose values cannot be read at all without checking the signature first. Approval runs on a fixed twenty-four hour window, and disclosure is prepaid per field so nothing is charged that was never released.",
    bullets: [
      "Onboard a business customer against registry data, not a scanned certificate.",
      "Quote a request before you create it and pay only for the fields released.",
    ],
  },
];

export const CONNECTOR_STEPS = [
  {
    step: "Step one",
    title: "Register your client",
    body: "Your OAuth 2.0 client is registered with the scopes you need, and the Connector environment is configured once by whoever runs your deployment.",
  },
  {
    step: "Step two",
    title: "Drop in the login page",
    body: "Your own markup and styling carry a QR code on desktop and a single link button on mobile, both filled in by the Connector when the page renders.",
  },
  {
    step: "Step three",
    title: "Exchange the code",
    body: "The redirect back to your application carries a code, the auth library turns it into a token, and the Core ID inside that token is your user.",
  },
];

export const CONNECTOR_FAQ = [
  {
    title: "Do our users need a CorePass account?",
    body: "Yes. A person installs CorePass, creates an account and verifies whichever documents they want to be able to share; from then on every site that uses the Connector is one scan away, and none of that verification work is repeated for each of them.",
  },
  {
    title: "What do we receive when someone logs in?",
    body: "A signed token carrying the person's Core ID, the address that identifies them across the Core ecosystem. It is stable, so it is what you store against your own user record, and there is no password, email address or phone number sitting beside it.",
  },
  {
    title: "How do we know a request for data will succeed?",
    body: "Ask first. A single call tells you which of the fields you need that person has already verified and which they have not, so you can either narrow the request or tell them what to verify before anything at all is shown to them.",
  },
  {
    title: "How is a delivery proven to be genuine?",
    body: "Every callback carries a signature header computed over the exact bytes you received, keyed with the secret registered for your domain. Verify it against that raw body rather than a re-serialised copy, and compare the timestamp with your own clock rather than one taken from inside the message.",
  },
  {
    title: "What does it cost to run?",
    body: "Personal data transfers pay the person in Core Token, and the Connector handles that settlement for you. Business data is prepaid per field in Swiss francs, priced by tier, quoted before you ask, reserved when a request is created and returned in full whenever a field is not released.",
  },
];
